export default __webpack_public_path__ + "assets/images/2.5da99a.png";